import { useState, useCallback } from 'react';

export interface ApiState<T> {
    data: T | null;
    loading: boolean;
    error: string | null;
}

export const useApiCall = <T>() => {
    const [state, setState] = useState<ApiState<T>>({
        data: null,
        loading: false,
        error: null,
    });

    const execute = useCallback(async (apiCall: () => Promise<T>): Promise<T | null> => {
        setState({ data: null, loading: true, error: null });

        try {
            const result = await apiCall();
            setState({ data: result, loading: false, error: null });
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setState({ data: null, loading: false, error: errorMessage });
            console.error('API Error:', err);
            return null;
        }
    }, []);

    const reset = useCallback(() => {
        setState({ data: null, loading: false, error: null });
    }, []);

    return {
        ...state,
        execute,
        reset,
    };
};

export const useApiRequest = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const request = useCallback(async <T>(apiCall: () => Promise<T>): Promise<T | null> => {
        setLoading(true);
        setError(null);

        try {
            const result = await apiCall();
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            console.error('API Error:', err);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    return { request, loading, error, setError };
};